class EnterActualsModalController {
  constructor($uibModalInstance, $http, $rootScope, $scope, $timeout, toastr, TravelExpenseService, expenseReport, expense, paymentMethods) {
    'ngInject';

    this.$uibModalInstance = $uibModalInstance;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.toastr = toastr;
    this.travelExpenseService = TravelExpenseService;

    this.expenseReport = expenseReport;
    this.createMode = !expense || !expense.id;
    this.expense = this.createMode
      ? { type: '', description: '' }
      : expense;
    this.paymentMethods = paymentMethods || [];
    this.apiHost = $rootScope.apiHost;

    this.isLodging = !this.createMode && !!this.expense.itinerary;
    this.estimatedAmount = this.isLodging
      ? this.travelExpenseService.getTotalLodging(this.expense)
      : (this.createMode ? null : (this.expense.amount || 0));
    this.estimatedMileage = (!this.createMode && this.expense.mileage != null)
      ? Number(this.expense.mileage)
      : null;

    const currentActual = this.isLodging
      ? this.expense.actualLodging
      : this.expense.actualAmount;

    this.actualAmount = (!this.createMode && currentActual != null) ? Number(currentActual) : null;
    this.actualAmountDisplay = '';
    this.actualMileage = null;
    this.paymentMethod = this.expense.paymentMethod || '';
    this.billableTrip = this.expenseReport && this.expenseReport.purpose === 'customer';
    this.billableToProject = this.billableTrip ? !!this.expense.billableToProject : false;
    this.receipts = (this.expense.receipts || []).slice();
    this.selectedFile = null;
    this.selectedFileName = null;
    this.errorMessage = '';
    this.saving = false;

    if (!this.createMode && this.isMileageExpense()) {
      this.initActualMileage();
    } else if (!this.createMode) {
      this.formatActualAmountDisplay();
    }

    this.$timeout(() => this.initFileSelector());
  }

  isCreateMode() {
    return !!this.createMode;
  }

  getTitle() {
    if (this.isCreateMode()) {
      return 'Add Expense';
    }

    if (this.isLodgingExpense()) {
      return 'Enter Lodging Actuals';
    }

    if (this.isMileageExpense()) {
      return 'Enter Mileage Actuals';
    }

    return 'Enter Expense Actuals';
  }

  getSubmitLabel() {
    if (this.saving) {
      return this.isCreateMode() ? 'Adding...' : 'Saving...';
    }

    return this.isCreateMode() ? 'Add Expense' : 'Save Actuals';
  }

  getExpenseLabel() {
    if (this.isLodgingExpense()) {
      return 'Lodging';
    }

    return this.expense.type || 'Expense';
  }

  getDescription() {
    if (this.isLodgingExpense()) {
      return 'Lodging for travel to ' + (this.expense.place || 'this location');
    }

    return this.expense.description || '';
  }

  isLodgingExpense() {
    return this.isLodging;
  }

  isMileageExpense() {
    return this.expense.type === 'Personally Owned Vehicle';
  }

  isBillableTrip() {
    return !!this.billableTrip;
  }

  showProjectBillingCertification() {
    return this.isBillableTrip() && !this.isLodgingExpense();
  }

  onExpenseTypeChange() {
    this.actualAmount = null;
    this.actualAmountDisplay = '';
    this.actualMileage = null;
    this.paymentMethod = '';
    this.clearSelectedFile();
    this.errorMessage = '';
    this.$timeout(() => this.initFileSelector());
  }

  initActualMileage() {
    if (this.actualAmount != null && !isNaN(this.actualAmount) && this.actualAmount > 0) {
      const rate = this.travelExpenseService.getPovMileageRate();
      this.actualMileage = Math.round((this.actualAmount / rate) * 10) / 10;
      return;
    }

    if (this.estimatedMileage != null && !isNaN(this.estimatedMileage) && this.estimatedMileage > 0) {
      this.actualMileage = this.estimatedMileage;
    }
  }

  getMileageRate() {
    return this.travelExpenseService.getPovMileageRate();
  }

  getActualMileageAmountPreview() {
    return this.travelExpenseService.calculateMileageAmount(this.actualMileage);
  }

  hasExistingReceipt() {
    return this.receipts && this.receipts.length > 0;
  }

  requiresPaymentAndReceipt() {
    // POV mileage does not require a receipt or payment method for submission.
    if (this.isMileageExpense()) {
      return false;
    }

    if (this.isLodgingExpense()) {
      return this.getParsedActualAmount() > 0;
    }

    return true;
  }

  formatCurrency(value) {
    return this.travelExpenseService.formatNumber(value || 0);
  }

  initFileSelector() {
    this.fileSelector = document.getElementById('actuals-receipt-file');

    if (!this.fileSelector) {
      return;
    }

    this.fileSelector.addEventListener('change', () => {
      const file = this.fileSelector.files && this.fileSelector.files[0];

      this.$scope.$apply(() => {
        this.selectedFile = file || null;
        this.selectedFileName = file ? file.name : null;
        this.errorMessage = '';
      });
    });
  }

  onActualAmountFocus() {
    if (this.actualAmount != null && !isNaN(this.actualAmount)) {
      this.actualAmountDisplay = String(this.actualAmount);
    }
  }

  onActualAmountBlur() {
    this.parseActualAmountDisplay();
    this.formatActualAmountDisplay();
  }

  parseActualAmountDisplay() {
    const raw = String(this.actualAmountDisplay || '').replace(/[^0-9.-]/g, '');
    const parsed = parseFloat(raw);
    this.actualAmount = isNaN(parsed) ? null : Math.round(parsed * 100) / 100;
  }

  formatActualAmountDisplay() {
    if (this.actualAmount == null || isNaN(this.actualAmount)) {
      this.actualAmountDisplay = '';
      return;
    }

    this.actualAmountDisplay = this.actualAmount.toFixed(2);
  }

  getParsedActualAmount() {
    this.parseActualAmountDisplay();
    return this.actualAmount == null || isNaN(this.actualAmount) ? 0 : this.actualAmount;
  }

  clearSelectedFile() {
    this.selectedFile = null;
    this.selectedFileName = null;

    if (this.fileSelector) {
      this.fileSelector.value = '';
    }
  }

  removeReceipt(receipt) {
    if (!receipt || !receipt.receipt || this.isCreateMode()) {
      return;
    }

    this.saving = true;
    this.travelExpenseService.removeReceipt(this.expenseReport.id, this.expense.id, receipt.receipt).then((response) => {
      this.receipts = (response.data && response.data.receipts) ? response.data.receipts : [];
      this.expense.receipts = this.receipts;
      this.saving = false;
      this.toastr.success('Receipt removed.', 'Updated');
    }, () => {
      this.saving = false;
      this.toastr.error('Could not remove the receipt.', 'Error');
    });
  }

  validate() {
    if (this.isCreateMode()) {
      if (!this.expense.type) {
        this.errorMessage = 'Select an expense type.';
        return false;
      }

      if (!this.expense.description || !String(this.expense.description).trim()) {
        this.errorMessage = 'Enter a description for this expense.';
        return false;
      }

      this.expense.description = String(this.expense.description).trim();
    }

    if (this.isMileageExpense()) {
      const mileage = parseFloat(this.actualMileage);

      if (isNaN(mileage) || mileage <= 0) {
        this.errorMessage = 'Enter actual mileage greater than zero.';
        return false;
      }

      this.actualMileage = Math.round(mileage * 10) / 10;
      this.actualAmount = this.travelExpenseService.calculateMileageAmount(this.actualMileage);
      this.errorMessage = '';
      return true;
    }

    this.parseActualAmountDisplay();

    if (this.actualAmount == null || isNaN(this.actualAmount) || this.actualAmount < 0) {
      this.errorMessage = 'Enter a valid actual amount of zero or greater.';
      return false;
    }

    if (this.isCreateMode() && this.actualAmount <= 0) {
      this.errorMessage = 'Enter an actual amount greater than zero.';
      return false;
    }

    if (this.requiresPaymentAndReceipt()) {
      if (!this.paymentMethod) {
        this.errorMessage = 'Select a payment method.';
        return false;
      }

      if (!this.hasExistingReceipt() && !this.selectedFile) {
        this.errorMessage = 'Upload a receipt for this expense.';
        return false;
      }
    }

    this.errorMessage = '';
    return true;
  }

  createExpense(payload) {
    return this.$http.post(
      this.$rootScope.apiHost + '/api/expense-reports/' + this.expenseReport.id + '/expenses',
      payload,
      { withCredentials: true }
    );
  }

  patchExpense(fields) {
    return this.$http.patch(
      this.$rootScope.apiHost + '/api/expense-reports/' + this.expenseReport.id + '/expenses/' + this.expense.id,
      fields,
      { withCredentials: true }
    );
  }

  uploadSelectedReceipt() {
    if (!this.selectedFile || !this.expense || !this.expense.id) {
      return Promise.resolve(null);
    }

    const formData = new FormData();
    formData.append('file', this.selectedFile);

    return this.$http.post(
      this.$rootScope.apiHost + '/api/expense-reports/' + this.expenseReport.id + '/expenses/' + this.expense.id + '/receipts',
      formData,
      {
        headers: {
          'Content-Type': undefined
        },
        withCredentials: true,
        transformRequest: (data) => data
      }
    );
  }

  buildActualsFields() {
    if (this.isLodgingExpense()) {
      const amount = this.getParsedActualAmount();
      return {
        actualLodging: amount,
        paymentMethod: amount > 0 ? this.paymentMethod : null
      };
    }

    if (this.isMileageExpense()) {
      return {
        actualAmount: this.actualAmount,
        paymentMethod: 'personal',
        billableToProject: this.showProjectBillingCertification() ? !!this.billableToProject : false
      };
    }

    return {
      actualAmount: this.getParsedActualAmount(),
      paymentMethod: this.paymentMethod || null,
      billableToProject: this.showProjectBillingCertification() ? !!this.billableToProject : false
    };
  }

  save() {
    if (!this.validate()) {
      return;
    }

    this.saving = true;
    const fields = this.buildActualsFields();

    const savePromise = this.isCreateMode()
      ? this.createExpense({
        type: this.expense.type,
        description: this.expense.description,
        // Late-added expenses have no separate estimate; mirror actual into amount.
        amount: this.isMileageExpense() ? this.actualAmount : fields.actualAmount
      }).then((response) => {
        this.expense = response.data;
        return this.patchExpense(fields);
      })
      : this.patchExpense(fields);

    savePromise.then(() => {
      return this.uploadSelectedReceipt();
    }).then(() => {
      this.saving = false;
      this.$uibModalInstance.close({
        expenseId: this.expense.id,
        fields,
        created: this.isCreateMode(),
        uploaded: !!this.selectedFile
      });
    }, () => {
      this.saving = false;
      this.errorMessage = this.isCreateMode()
        ? 'Could not add the expense. Please try again.'
        : 'Could not save actuals. Please try again.';
    });
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default EnterActualsModalController;



// WEBPACK FOOTER //
// ./client/pages/expenses/modals/enter-actuals/enter-actuals.controller.js